export { default } from './blog-hero';
export { default as BlogHeroConfig } from './blog-hero.config';
